module.exports = __webpack_public_path__ + "bb4e8f12354f2eb0e221f04008520f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-320.jpg
// module id = 223
// module chunks = 0